
/**
 *
 */
export default class CustomApi {
  /**
   * Auth
   */
  auth = {
    info: (companyId, courseId) => $app.api.get([ 'auth/info', ]).query({ companyId, courseId, }),
    login: (data) => $app.api.post('auth/login').data(data),
    register: (data, token = '') => $app.api.post([ 'auth/register*', token, ]).data(data),
  }
  
  /**
   * Base
   */
  files = {
    get: (id) => $app.api.get([ 'files*', id, ]),
    create: (data) => {
      const formData = new FormData()
      $n.each(data, (value, name) => {
        formData.append(name, value)
      })
      return $app.api.post([ 'files', ]).data(formData).config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
    delete: (id) => $app.api.delete([ 'files*', id, ]),
  }
  locale = {
    get: (id) => $app.api.get([ 'locales*', id, ]),
    set: (id) => $app.api.post([ 'locales*', id, ]),
    elements: {
      get: () => $app.api.get([ 'elements', ]),
    },
  }
  translations = {
    getByTag: (tag) => $app.api.get([ 'base/translations*', tag, ]),
    edit: (id, data) => $app.api.patch([ 'base/translations*', id, ]).data(data),
  }
  
  /**
   * App
   */
  app = {
    categories: {
      get: (id) => $app.api.get([ 'categories*', id, ]),
      create: (data) => $app.api.post([ 'categories', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'categories*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'categories*', id, ]),
    },
    types: {
      get: (id) => $app.api.get([ 'types*', id, ]),
      create: (data) => $app.api.post([ 'types', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'types*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'types*', id, ]),
    },
    students: {
      get: (id) => $app.api.get([ 'students*', id, ]),
      create: (data) => $app.api.post([ 'students', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'students*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'students*', id, ]),
    },
    banners: {
      get: (id) => $app.api.get([ 'banners*', id, ]),
      create: (data) => $app.api.post([ 'banners', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'banners*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'banners*', id, ]),
    },
    faqs: {
      get: (id) => $app.api.get([ 'faqs*', id, ]),
      create: (data) => $app.api.post([ 'faqs', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'faqs*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'faqs*', id, ]),
    },
    articles: {
      get: (id) => $app.api.get([ 'articles*', id, ]),
      create: (data) => $app.api.post([ 'articles', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'articles*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'articles*', id, ]),
    },
    partners: {
      get: (id) => $app.api.get([ 'partners*', id, ]),
      create: (data) => $app.api.post([ 'partners', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'partners*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'partners*', id, ]),
    },
    teachers: {
      get: (id) => $app.api.get([ 'teachers*', id, ]),
      create: (data) => $app.api.post([ 'teachers', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'teachers*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'teachers*', id, ]),
    },
    certs: {
      get: (id) => $app.api.get([ 'certs*', id, ]),
      create: (data) => $app.api.post([ 'certs', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'certs*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'certs*', id, ]),
    },
    images: {
      get: (id) => $app.api.get([ 'images*', id, ]),
      getFiles: (id) => $app.api.get([ 'images/files', id, ]),
      edit: (id, data) => $app.api.patch([ 'images*', id, ]).data(data),
    },
    pages: {
      get: (id) => $app.api.get([ 'pages*', id, ]),
      edit: (id, data) => $app.api.patch([ 'pages*', id, ]).data(data),
    },
    courses: {
      get: (id) => $app.api.get([ 'courses*', id, ]),
      create: (data) => $app.api.post([ 'courses', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'courses*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'courses*', id, ]),
      images: {
        add: (id, data) => $app.api.post([ 'courses*/images', id, ]).data(data),
        setAvatar: (id, imageId) => $app.api.post([ 'courses*/avatar*', id, imageId, ]),
        delete: (id, imageId) => $app.api.delete([ 'courses*/images*', id, imageId, ]),
      },
    },
    users: {
      get: (id) => $app.api.get([ 'users*', id, ]),
      create: (data) => $app.api.post([ 'users', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'users*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'users*', id, ]),
    },
    accounts: {
      get: (id) => $app.api.get([ 'accounts*', id, ]),
    },
    pays: {
      get: (id) => $app.api.get([ 'pays*', id, ]),
    },
    documents: {
      get: (id) => $app.api.get([ 'documents*', id, ]),
      create: (data) => $app.api.post([ 'documents', ]).data(data),
      edit: (id, data) => $app.api.patch([ 'documents*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'documents*', id, ]),
    },
  }
}
